export enum AdEventType {
  TwoSecondView = 0,
  FullView = 1,
  FailedToPlay = 2,
}
